<template>
  <div class="mt-4 space-y-4">
    <div v-if="this.reviews.length === 0" class="text-gray-500">
      {{ $t('product.noReviewsAvailable') }}
    </div>
    <div v-else>
      <div
        v-for="review in this.reviews"
        :key="review._id"
        class="p-4 border rounded-lg bg-white shadow-sm"
      >
        <div class="flex justify-between items-center mb-1">
          <h4 class="font-semibold text-lg">{{ review._recensore[0]?.name || $t('product.anonymous') }}</h4>
          <span class="text-sm text-gray-400">{{ formatDate(review.creationDate) }}</span>
        </div>
        <div class="text-yellow-500 mb-2">
          <StarRatings
            v-model="review.voto"
            :numberOfStars="5"
            :starSize="28"
            :starColor="'#fbbf24'"
            :inactiveColor="'#d1d5db'"
            :disableClick="true"
          />
        </div>
        <p class="text-gray-700">{{ review.messaggio }}</p>
      </div>
      <div class="d-flex mt-4 justify-content-center">
        <ButtonFilled
          v-if="this.currentPage < this.totalPages"
          class="fw-bold ms-md-4 text-center"
          :hasRoundedCorners="true"
          @click="loadMore"
          :text="loading ? $t('common.loading') : $t('common.loadMore')"
        />
      </div>
    </div>
    <AddReview :productId="productId" @review-submitted="onReviewSubmitted" />
  </div>
</template>

<script>
import { getProductReviews } from '../../../composables/manageReviews'
import StarRatings from 'vue3-star-ratings'
import ButtonFilled from '../Button/ButtonFilled.vue'
import AddReview from './AddReview.vue'

export default {
  props: {
    productId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      reviews: [],
      perPage: 5,
      currentPage: 1,
      totalPages: 1,
      loading: true,
    }
  },
  components: { StarRatings, ButtonFilled, AddReview },
  mounted() {
    this.fetchReviews()
  },
  watch: {
    productId() {
      this.currentPage = 1
      this.reviews = []
      this.fetchReviews()
    }
  },
  methods: {
    async fetchReviews () {
      try {
        this.loading = true;
        const res  = await getProductReviews(this.productId, this.perPage, this.currentPage);
        const newReviews = res.recensioni || [];
        this.totalPages = res.totPages || 1;

        if (this.currentPage === 1) {
          this.reviews = newReviews
        } else {
          this.reviews = [...this.reviews, ...newReviews]
        }
      } catch (err) {
        console.error('Error fetching reviews:', err);
        this.reviews = [];
      } finally {
        this.loading = false;
      }
    },
    formatDate(dateString) {
      const options = { year: 'numeric', month: 'short', day: 'numeric' }
      return new Date(dateString).toLocaleDateString(undefined, options)
    },
    async loadMore() {
      if (this.currentPage < this.totalPages) {
        this.currentPage += 1;
        await this.fetchReviews()
      }
    },
    async onReviewSubmitted() {
      this.currentPage = 1;
      await this.fetchReviews();
    }
  }
}
</script>

<style scoped>
/* Optional styling for better visuals */
</style>